import { classes, Heading } from '@dittolive/anvil'
import React from 'react'

import {
  ConnectorInitialSyncStatus,
  InitialSyncState,
} from '../../../types/mongoConnector'

type Props = {
  statuses: ConnectorInitialSyncStatus[]
  isLoading?: boolean
}

export default function MongoConnectorInitialSyncStatus({
  statuses,
  isLoading,
}: Props) {
  if (isLoading || !statuses || statuses.length === 0) {
    return null
  }

  const getStatusText = (status: InitialSyncState) => {
    switch (status) {
      case 'completed':
        return 'Completed'
      case 'partially_completed':
        return 'Partially Completed'
      case 'failed':
        return 'Failed'
      default:
        return 'In Progress'
    }
  }

  return (
    <div className="flex flex-col gap-y-2">
      <div>
        <Heading level={3}>Initial Sync Status</Heading>
        <p className="text-foreground-subtle text-base">
          The status of the collections triggering initial sync with
        </p>
      </div>

      <div className="border-border-normal overflow-hidden rounded-xl border">
        <table className="divide-border-normal w-full divide-y">
          <thead>
            <tr key="initial-sync-status-header" className="text-left">
              <th className="py-2.5 pl-4 pr-5 font-semibold">Collection</th>
              <th className="py-2.5 pl-4 pr-5 font-semibold">Progress</th>
              <th className="py-2.5 pl-4 pr-5 font-semibold">Status</th>
            </tr>
          </thead>

          <tbody>
            {statuses.map((statusItem, index) => (
              <tr key={`initial-sync-status-${index}`}>
                <td className="py-2.5 pl-4 pr-5">
                  {statusItem.collectionName}
                </td>

                <td className="py-2.5 pl-4 pr-5">
                  {statusItem.syncedDocumentCount} /{' '}
                  {statusItem.totalEstimatedDocumentCount}
                </td>

                <td className="py-2.5 pl-4 pr-5">
                  <span
                    className={classes(
                      'inline-flex items-center rounded-md px-1.5 py-0.5 text-sm font-medium',
                      {
                        'bg-fill-success-secondary text-fill-success':
                          statusItem.status === 'completed',
                        'bg-fill-warning-secondary text-fill-warning':
                          statusItem.status === 'partially_completed',
                        'bg-fill-critical-secondary text-fill-critical':
                          statusItem.status === 'failed',
                        'bg-fill-info-secondary text-fill-info':
                          statusItem.status === 'in_progress',
                      },
                    )}
                  >
                    {getStatusText(statusItem.status)}
                  </span>
                  <p className="mt-2 text-sm italic">
                    {(statusItem.status === 'failed' ||
                      statusItem.status === 'partially_completed') &&
                      `(${statusItem.failedDocumentCount ?? 0} documents failed to sync)`}
                  </p>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
